import React from 'react';
import { MapPin, ArrowUpRight } from 'lucide-react';
import { useI18n } from '../i18n';

const GMAPS_URL = 'https://maps.app.goo.gl/YskxvkdzUFKUKY5i8';
const MAP_EMBED_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d186.80906815682766!2d2.0657094576244974!3d41.48379011500646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a4910af4037dab%3A0x26a0ebaa53cc6e1e!2sVIDAT%20Instituto%20de%20Inteligencia%20M%C3%A9dica!5e0!3m2!1ses!2ses!4v1783610073582!5m2!1ses!2ses';

const HomeLocationBlock = () => {
  const { t } = useI18n();

  return (
    <section
      className="bg-ivory py-24 lg:py-32"
      data-testid="home-location-block"
      aria-labelledby="home-location-heading"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <div className="overline mb-6">{t('location.eyebrow')}</div>
            <h2
              id="home-location-heading"
              className="display-md text-cyan-vidat mb-8"
            >
              {t('location.homeIntro1')}
            </h2>
            <span className="section-rule mb-8"></span>
            <p className="text-lg text-stone-700 font-light leading-relaxed mb-6">
              {t('location.homeIntro2')}
            </p>
            <div className="flex items-start gap-3 mb-8">
              <MapPin
                size={18}
                strokeWidth={1.5}
                className="text-cyan-vidat mt-1 flex-shrink-0"
                aria-hidden="true"
              />
              <address
                className="not-italic text-base text-stone-700 font-light leading-relaxed"
                data-testid="home-location-address"
              >
                {t('location.address')}
              </address>
            </div>
            <a
              href={GMAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="home-location-cta"
            >
              {t('location.mapButton')}
              <ArrowUpRight size={16} strokeWidth={1.5} />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div
              className="aspect-[4/3] w-full overflow-hidden border border-stone-200 bg-stone-100"
              data-testid="home-location-map"
            >
              <iframe
                src={MAP_EMBED_SRC}
                title="Ubicación de VIDAT en Google Maps"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block', width: '100%', height: '100%' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeLocationBlock;
